import { assign, has, isEmpty } from 'lodash';
import { addFilter } from '@wordpress/hooks';
// import { createHigherOrderComponent } from '@wordpress/compose';
import { select } from '@wordpress/data';

// Enable Responsive disply control on the following blocks
const enabledBlocks = [
	// 'core/button',
	// 'core/buttons',
	// 'core/group',
	// 'gutenify/gallery-carousel',
	// 'gutenify/map',
	// 'gutenify/container',
	// 'gutenify/buttons',
	// 'gutenify/button',
	// 'gutenify/icon',
	// 'gutenify/info-box',
	// 'gutenify/service',
	// 'gutenify/section-title',
	// 'gutenify/star-rating',
	// 'gutenify/testimonial',
	// 'gutenify/testimonials',
	// 'gutenify/team-member',
	// 'gutenify/team',
	// 'gutenify/post-carousel',
	// 'gutenify/slide-item',
	// 'gutenify/faqs',
	// 'gutenify/content-toggle-item',

	// PRO
	'gutenify/instagram',
];

const addAttributes = ( settings, name ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! enabledBlocks.includes( name ) ) {
		return settings;
	}

	if ( ! has( settings, 'attributes.blockClientId' ) ) {
		// Use Lodash's assign to gracefully handle if attributes are undefined
		settings.attributes = assign( settings.attributes, {
			blockClientId: {
				type: 'string',
				default: '',
			},
		} );
	}

	return settings;
};

addFilter(
	'blocks.registerBlockType',
	'extend-block-example/attribute/spacing',
	addAttributes
);

const addSpacingExtraProps = ( saveElementProps, blockType, attributes ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! enabledBlocks.includes( blockType.name ) ) {
		return saveElementProps;
	}

	if ( ! isEmpty( select( 'core/editor' ).getCurrentPostType() ) ) {
		const classNames = saveElementProps.className.split( ' ' );

		const result = classNames.filter( ( cls ) => cls.indexOf( 'gutenify-section' ) < 0 );

		result.push( `gutenify-section-${ attributes.blockClientId }` );

		saveElementProps.className = result.join( ' ' );
	}
	// && isEmpty( select( 'core/editor' ).getCurrentPostType() )

	return saveElementProps;
};

addFilter(
	'blocks.getSaveContent.extraProps',
	'extend-block-example/get-save-content/extra-props',
	addSpacingExtraProps
);

/**
 * React hook function to override the default block element to add wrapper props.
 *
 * @function addEditorBlockAttributes
 * @param {Object} BlockListBlock Block and its wrapper in the editor.
 * @return {Object} BlockListBlock extended
 */
// const addAllEditorProps = createHigherOrderComponent(
// 	( BlockListBlock ) => {
// 	    return ( props ) => {
// 			return (
// 				<BlockListBlock
// 					{ ...props }
// 					className={ 'blocksss-' + props.clientId }
// 		    />
// 			);
// 	    };
// 	},
// 	'withClientIdClassName'
// );

// addFilter(
// 	'editor.BlockListBlock',
// 	'coblocks/applyEditorProps',
// 	addAllEditorProps
// );
